<template>
  <div>
    <img src="/static/img/backToTop/back_to_top_2x.png" alt="Top" @click="backToTop" v-show="show">
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    name: 'back-to-top',
    data() {
      return {
        show: false
      }
    },
    mounted() {
      let vm = this
      $(document).on('scroll', function () {
        if ($(window).scrollTop() >= 736) {
          vm.show = true
        } else {
          vm.show = false
        }
      })
    },
    methods: {
      backToTop() {
        $('body, html').animate({
          scrollTop: 0
        }, 600)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  div {
    width: .4rem;
    height: .4rem;
    position: fixed;
    right: .3rem;
    bottom: .7rem;
    z-index: 10;
    img {
      width: 100%;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// BackToTop.vue?09821296